module.exports = __webpack_public_path__ + "files/73d6bb0d4f596a91992e6be32e82e3bc.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-800italic.ttf
 ** module id = 971
 ** module chunks = 0
 **/